import { render, staticRenderFns } from "./projectOverview.vue?vue&type=template&id=0584db27&scoped=true&"
import script from "./projectOverview.vue?vue&type=script&lang=js&"
export * from "./projectOverview.vue?vue&type=script&lang=js&"
import style0 from "./projectOverview.vue?vue&type=style&index=0&id=0584db27&prod&lang=less&scoped=true&"
import style1 from "./projectOverview.vue?vue&type=style&index=1&id=0584db27&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0584db27",
  null
  
)

export default component.exports